<template>
  <div class="claps-animation">
    <lottie-player
      src="/lottie/claps.json"
      background="transparent"
      speed="1"
      :loop="false"
      autoplay
      class="claps-animation-left"
    />

    <lottie-player
      src="/lottie/claps.json"
      background="transparent"
      speed="1"
      :loop="false"
      autoplay
      class="claps-animation-right"
    />
  </div>
</template>
<script setup lang="ts"></script>

<style scoped>
.claps-animation {
  position: absolute;
  top: 0px;
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  left: 0px;
  z-index: 2500;
}

.claps-animation-left {
  margin-top: 60px;
  margin-right: 54px;
}

.claps-animation-left,
.claps-animation-right {
  height: 300px;
  width: 120px;
  height: 300px;
  width: 120px;
}
</style>
